import React from 'react';
import { compose } from 'ramda';

import { RichText } from '@synergycms_core/components/generic';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './RelatedAvail.js';
import { validateAsyncComponent } from '../../HoC';
import connect from 'react-redux/es/connect/connect';
import {AvailHotelDetailNoAvail} from '../../../views/multiHotelAvail/AvailHotelDetail';
import { checkAvailSegments, reduceWhileResolved } from '../../../utils';
import { List } from 'immutable';

import Slider from '@synergycms_core/components/generic/NewSlide';
import SlideItem from '@synergycms_core/components/generic/NewSlide/SlideItem';
import SlideButton from '@synergycms_core/components/generic/NewSlide/SlideButton';
import { withSlide } from '@synergycms_core/components/providers/slideProvider';





const RelatedAvail = class RelatedAvail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPhoto: 0,
      showDatepickerAvail: false,
      showCalendar: false,
      hover: false,
      showMapToolTip: false,
      currentHotel: null,
    };
  }
  static displayName = 'RelatedAvail';
  

  onRangeChange = (dates) => {
    this.setState(state => ({
      dates: dates
    }));
  };

  isMobile = () => {
    return this.props.theme.deviceType !== 'DESK';
  };

  getVisibleItems = (availableHotels) => {
    const { width } = this.props.theme;

    switch (true) {
      case (width > 1120):
        return 3;
      case (width > 901):
        return 2;
      case (width < 801 && availableHotels && availableHotels.size > 1):
        return 1.1;
      default:
        return 1;
    }
  };

  onHover = hotelId => e => {
    e.preventDefault();
    this.setState((state, props) => ({
      hover: hotelId
    }));
  };

  eventShowMapToolTip = hotelId => e => {
    if (hotelId !== this.state.showMapToolTip) {
      this.setState((state, props) => ({
        showMapToolTip: hotelId
      }));
    }
  };

  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    const { availableHotels, city, isPortal } = config;

    const visibleItems = this.getVisibleItems();
    const notDrag = availableHotels?.size <= visibleItems;
    const itemsGap = this.isMobile() ? 20 : 30;

    return (
      <div className={[theme.computedInnerStyle, classes.removePadding]}>
        {city && isPortal ? (
          <>
            {availableHotels.size > 0 &&
              <>

                <div className={classes.alternativeDispoContainer}>
                  <RichText text={availableHotels.size} innerStyle={['roboto13BoldBlack']} translate={true} />{' '}
                  <RichText text={'_%hotel%_'} innerStyle={['roboto13BoldBlack']} translate={true} plural={availableHotels.size > 1} />{' '}
                  <RichText text={'_%disponible en%_'} innerStyle={['roboto13Black']} translate={true} plural={availableHotels.size > 1} />{' '}
                  <RichText text={city.get('name')} innerStyle={['roboto13BoldBlack']} translate={true} />{' '}
                  <RichText text={'_%para estas fechas%_'} innerStyle={['roboto13Black']} translate={true} />
                </div>

                <div className={classes.slideContainer}>

                  <Slider 
                    visibleItems={this.getVisibleItems(availableHotels)}
                    snapToLastElement={true}

                    // TRANSITIONS
                    //customTransition={'all 5s ease-in-out'}
                    transitionDuration={500}
                    
                    // AUTOPLAY
                    //autoPlay={true}
                    //autoPlaySpeed={4000}
                    
                    // ACTIONS
                    touchDraggable={!notDrag}
                    cursorDraggable={!notDrag}
                    itemsGap={itemsGap}
                  >

                    {!this.isMobile() && (
                      <SlideButton
                        direction={'prev'}
                        className={`${classes.botButton} ${notDrag ? classes.disabledButton : ''}`}
                      >
                        <RichText icon={{ content: '\\', innerStyle: ['mainColor', 'size14'] }} />
                      </SlideButton>
                    )}

                    {availableHotels && availableHotels.map(hotelId => {
                      return (
                        <SlideItem className={classes.slideMargin}>
                          <AvailHotelDetailNoAvail
                            onHover={this.onHover}
                            eventShowMapToolTip={this.eventShowMapToolTip}
                            key={hotelId}
                            hotelId={hotelId}
                            slide={true}
                          />
                        </SlideItem>
                      );
                    })}

                    {!this.isMobile() && (
                      <SlideButton
                        direction={'next'}
                        className={`${classes.topButton} ${notDrag ? classes.disabledButton : ''}`}
                      >
                        <RichText icon={{ unicodeContent: 'e000', innerStyle: ['mainColor', 'size14'] }} />
                      </SlideButton>
                    )}

                  </Slider>
                </div>
              </>
            }
          </>
        ) : null}
      </div>
    );
  }
};


const mapStateToProps = store => {
  const urlParams = store.getIn(['customer', 'params', 'url_params'], undefined);

  const params = store.getIn(['customer', 'params', 'params'], undefined);
  const city =
    store.getIn(['customer', 'web_type'], false) !== 'WI' &&
    params &&
    params.get('city_id') &&
    store.getIn(['hotels', 'hotels_info', 'cities']).find(city => {
      return city.get('id') === parseInt(params.get('city_id'), 10);
    });
  const webType = store.getIn(['customer', 'web_type'], false);
  const isPortal = webType === 'PORTAL';
  if (!city || !isPortal) return {
    urlParams,
    availableHotels: null,
    city: null,
    loadingRelated: false,
    isPortal
  };
  let cityId = city.get('id');
  var hotelIds = store.getIn(['hotels'])
    .getIn(['hotels_info', 'hotels'])
    .filter(h => h.get('city_id') === cityId)
    .toJS()
    .reduce((hotelsCity, hotel) => hotelsCity.concat([hotel.id]), List());
  
  reduceWhileResolved(store,'hotels',hotelIds);
  const hotelsAvail = reduceWhileResolved(store, 'avail',hotelIds);
  
  const availableHotels = hotelsAvail && hotelsAvail.filter(function(hotelAvail, hotelId) {
    let string_params = store.getIn([
      'avail',
      hotelId,
      store.getIn(['hotels', hotelId, 'params', store.getIn(["availQuery", "multi", "string_params"])]),
      'raw_response'
    ]);
    return checkAvailSegments(string_params)
  }).keySeq().map(key => key);
  
  return {
    urlParams,
    availableHotels,
    city,
    isPortal
  };
};


const fragment = props => {
  return (
    <></>
  );
};



export default compose(
  withSlide,
  validateAsyncComponent(mapStateToProps,[],fragment),
  connect(
    mapStateToProps
  ),
  PropertyManager(['type', 'showButton', 'urlParams', 'availableHotels', 'city', 'currentDate', 'availDate', 'showEngine', 'goBack', 'objVars', 'newRange', 'isPortal']),
  withThemeJSS({ styleFile, link: true })
)(RelatedAvail);
